module.exports = __webpack_public_path__ + "static/img/habilitados_exámenes_orales.ff2afce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/habilitados_exámenes_orales.png
// module id = 6UbJ
// module chunks = 9